// extracted by mini-css-extract-plugin
export default {"container":"fp-z","brandName":"gp-z","productName":"hp-z","productNamePdpEnhancements":"ip-z","breakLongProductName":"jp-z"};